import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResultDataService {
  associatedEstimates: any

  parentData: any = {
    estimates: null,
    name: ''
  };

  setParentData(data: any) {
    this.parentData = data;
  }

  getParentData() {
    return this.parentData;
  }

  setAssociatedEstimatesData(data: any) {
    this.associatedEstimates = data;
  }

  getAssociatedEstimatesData() {
    return this.associatedEstimates;
  }
}